<template src='./tiemposPaciente.html'></template>
<script>
export default {
  data() {
    return {
      color: "",
      estado: ["Nueva", "Autorizada", "Asignada", "Factura", "Completada"],
      cambioEntero: [],
      arrayColores: []
    };
  },
  props: {
    datosUsuarios: {
      type: Object,
      required: true
    }
  },
  beforeMount() {
    this.cambiarColor();
  },
  methods: {
    cambiarColor() {
      this.arrayColores = this.datosUsuarios.fechas.map(item => {
        item != "Pendiente" ? (this.color = "#00C851") : (this.color = "#c4cacf");
        return this.color;
      });
    }
  },
  filters: {
    cambioDecimales: function(value) {
      return (value = Math.round(value));
    }
  }
};
</script>

<style lang="scss" src='./tiemposPaciente.scss' scoped>
</style>
<style lang="scss">
.contenedorTiempoPaciente {
  .contenedorStepper {
    .cabezaStepper {
      .tamanoPosicion {
        .v-application .primary {
          color: red;
        }
        div {
          display: flex !important;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Gestion/TiemposPaciente/tiemposPaciente.vue